const initialState = {
    loading: false,
    error: null,
    message:null,
    permissionList:null,
    permission:null,
    groupList:null,
    group:null,
    userList:null,
    groupPermission:null,
    userPermission:null,
    user:null,
}

const PermissionReducer = (state = initialState, action) => {
    switch(action.type){
        case 'GET_CMS_CONTENT_TYPE':
             return {
                 ...state,
                 content_type:action.payload,
                 loading:false
             }    
        case 'GET_CMS_PERMISSION_LIST_REQUEST':
            return {
                ...state,
                loading:true,
            }    
        case 'GET_CMS_PERMISSION_LIST_SUCCESS':
            return {
                ...state,
                loading:false,
                permissionList:action.payload,
            }
        case 'GET_CMS_PERMISSION_LIST_FAILURE':
            return {
                ...state,
                loading:false,
                error:action.payload,
            }            
        case 'CLEAR_PERMISSION_LIST':
            return{
                ...state,
                permissionList:null
            }

        case 'GET_CMS_PERMISSION_REQUEST':
            return {
                ...state,
                loading:true,
            }
        case 'GET_CMS_PERMISSION_SUCCESS':
            return {
                ...state,
                loading:false,
                permission:action.payload
            }    
        case 'GET_CMS_PERMISSION_FAILURE':
            return {
                ...state,
                loading:false,
                error:action.payload
            }
        
        case 'CLEAR_PERMISSION':
            return{
                ...state,
                permission:null

            }

        case 'EDIT_CMS_PERMISSION_REQUEST':
            return{
                ...state,
                loading:true
            }
        case 'EDIT_CMS_PERMISSION_SUCCESS':
            return{
                ...state,
                permission:action.payload,
                loading:false,
                message:'Permission Edited SuccessFully'
            }
        case 'EDIT_CMS_PERMISSION_FAILURE':
            return{
                ...state,
                error:action.payload,
                loading:false,
                message:'Edit Permission Failure'
            }
        
        case 'POST_CMS_PERMISSION_SUCCESS':
            return{
                ...state,
                permissionList:[...state.permissionList,action.payload],
                message:'Permission Added Successfully',
                error:false
            }
        case 'POST_CMS_PERMISSION_FAILURE':
            return{
                ...state,
                error:action.payload,
                message:'Add Permission Failure',
            }    
        case 'CLEAR_PERMISSION_RESPONSE' :
            return{
                ...state,
                message:null,
                error:null
            }
        case 'DELETE_CMS_PERMISSION_SUCCESS':
            let id=action.payload 
            let list=state.permissionList && state.permissionList.filter(obj => obj.id !== id)
            return {
                ...state,
                permissionList:list,
            }
        case 'DELETE_CMS_PERMISSION_FAILURE':
            return{
                ...state,
                error:action.payload
            }
        
        case 'GET_CMS_GROUP_LIST_REQUEST':
            return {
                ...state,
                loading:true,
            }    
        case 'GET_CMS_GROUP_LIST_SUCCESS':
            return {
                ...state,
                loading:false,
                groupList:action.payload,
            }
        case 'GET_CMS_GROUP_LIST_FAILURE':
            return {
                ...state,
                loading:false,
                error:action.payload,
            }
        case 'CLEAR_GROUP_LIST':
            return {
                ...state,
                groupList:null
            }

        case 'GET_CMS_GROUP_REQUEST':
            return {
                ...state,
                loading:true
            }
        case 'GET_CMS_GROUP_SUCCESS':
            return {
                ...state,
                group:action.payload,
                loading:false
            }
        case 'GET_CMS_GROUP_FAILURE':
            return{
                ...state,
                error:action.payload,
                loading:false
            }
        case 'CLEAR_GROUP':
            return{
                ...state,
                group:null,
            }
        case 'ADD_CMS_GROUP_SUCCESS':
            return{
                ...state,
                groupList:[...state.groupList,action.payload],
                message:'Group Added Successfully',
                error:false
            }
        case 'ADD_CMS_GROUP_FAILURE':
            return{
                ...state,
                error:action.payload,
                message:'Add Group Failure', 
            }    
        case 'CLEAR_ADD_GROUP_RESPONSE' :
            return{
                ...state,
                message:null,
                error:null
            }
        case 'EDIT_CMS_GROUP_REQUEST':
            return{
                ...state,
                loading:true
            }
        case 'EDIT_CMS_GROUP_SUCCESS':
            return{
                ...state,
                group:action.payload,
                loading:false,
                message:'Group Edited Successfully',
                error:false
            }
        case 'EDIT_CMS_GROUP_FAILURE':
            return{
                ...state,
                error:action.payload,
                loading:false,
                message:'Edit Group Failure'
            }
        case 'GET_USER_LIST_REQUEST':
            return {
                ...state,
                loading:true,
            }    
        case 'GET_USER_LIST_SUCCESS':
            return {
                ...state,
                loading:false,
                userList:action.payload,
            }
        case 'GET_USER_LIST_FAILURE':
            return {
                ...state,
                loading:false,
                error:action.payload,
            }
        case 'CLEAR_USER_LIST':
            return{
                ...state,
                userList:null,
            }
        case 'GET_CMS_GROUP_PERMISSION_REQUEST':
            return {
                ...state,
                loading:true,
            }
        case 'GET_CMS_GROUP_PERMISSION_SUCCESS':
            return {
                ...state,
                loading:false,
                groupPermission:action.payload
            }    
        case 'GET_CMS_GROUP_PERMISSION_FAILURE':
            return {
                ...state,
                loading:false,
                error:action.payload
            }
        case 'CLEAR_GROUP_PERMISSION':
            return{
                ...state,
                groupPermission:null
            }
        case 'CHANGE_GROUP_LIST_STATUS':
            let data=state.groupPermission
            data[action.payload.id].status=action.payload.status
            return{
                    ...state,
                    groupPermission:data
                }
                
        case 'GET_CMS_USER_PERMISSION_REQUEST':
            return {
                ...state,
                loading:true,
            }
        case 'GET_CMS_USER_PERMISSION_SUCCESS':
            return {
                ...state,
                loading:false,
                userPermission:action.payload
            }    
        case 'GET_CMS_USER_PERMISSION_FAILURE':
            return {
                ...state,
                loading:false,
                error:action.payload
            }
        case 'CLEAR_USER_PERMISSION':
            return{
                ...state,
                userPermission:null
            }
        case 'CHANGE_USER_LIST_STATUS':
            let userliststatus=state.userPermission
            userliststatus[action.payload.id].status=action.payload.status
            return{
                    ...state,
                    userPermission:userliststatus
            }
            
        case 'GET_USER_REQUEST':
            return {
                ...state,
                loading:true
            }
        case 'GET_USER_SUCCESS':
            return {
                ...state,
                user:action.payload,
                loading:false
            }
        case 'GET_USER_FAILURE':
            return{
                ...state,
                error:action.payload,
                loading:false
            }
        case 'CLEAR_USER':
            return{
                ...state,
                user:null,
            }
        
        case 'PUT_CMS_GROUP_PERMISSION_SUCCESS':
            return{
                ...state,
                putCmsGroupPermission:action.payload,
            }    
        case 'PUT_CMS_GROUP_PERMISSION_FAILURE':
            return{
                ...state,
                putCmsGroupPermissionError:action.payload
            }

        case 'DELETE_CMS_GROUP_PERMISSION_SUCCESS':
            return{
                ...state,
                deleteCmsGroupPermission:action.payload
            }
        case 'DELETE_CMS_GROUP_PERMISSION_FAILURE':
            return{
                ...state,
                deleteCmsGroupPermissionError:action.payload
            }    
        case 'PUT_CMS_USER_PERMISSION_SUCCESS':
            return{
                ...state,
                putCmsUserPermission:action.payload,
            }    
        case 'PUT_CMS_USER_PERMISSION_FAILURE':
            return{
                ...state,
                putCmsUserPermissionError:action.payload
            }

        case 'DELETE_CMS_USER_PERMISSION_SUCCESS':
            return{
                ...state,
                deleteCmsUserPermission:action.payload
            }
        case 'DELETE_CMS_USER_PERMISSION_FAILURE':
            return{
                ...state,
                deleteCmsUserPermissionError:action.payload
            }    

        default: return state
    }
}

export default PermissionReducer